import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.6652 10.8236C18.1116 10.3681 18.1116 9.62827 17.6652 9.17272L11.9506 3.34166C11.5041 2.88611 10.7791 2.88611 10.3326 3.34166C9.88615 3.79721 9.88615 4.53703 10.3326 4.99258L14.1007 8.83379H3.14292C2.51074 8.83379 2 9.35494 2 10C2 10.6451 2.51074 11.1662 3.14292 11.1662H14.0971L10.3362 15.0074C9.88973 15.463 9.88973 16.2028 10.3362 16.6583C10.7826 17.1139 11.5077 17.1139 11.9541 16.6583L17.6687 10.8273L17.6652 10.8236Z",
		fill: "#0D2976"
	})
});
export default SvgArrowRight;
